import { AsyncState } from '@c42/constants';
import { StsEmployeeDetails } from '@c42/jwt/dist/constants';
import React from 'react';
import { useHistory } from 'react-router';
import c42Jwt from '../../constants/c42Jwt';
import { LOGIN_INDEX } from '../../constants/routes';

type Result = {
  employeeDetails?: StsEmployeeDetails;
  loadingState: AsyncState;
  notFound: boolean;
  error: boolean;
  lookup: (employeeId: string) => Promise<void>;
};

export const useEmployeeDetails = (): Result => {
  const [employeeDetails, setEmployeeDetails] = React.useState<StsEmployeeDetails>();
  const [loadingState, setLoadingState] = React.useState<AsyncState>(AsyncState.NOT_STARTED);
  const [notFound, setNotFound] = React.useState(false);
  const [error, setError] = React.useState(false);

  const history = useHistory();

  const lookup = async (employeeId: string): Promise<void> => {
    setLoadingState(AsyncState.LOADING);
    setNotFound(false);
    setError(false);
    setEmployeeDetails(undefined);
    try {
      const data = await c42Jwt.getEmployeeDetails(employeeId);
      setEmployeeDetails(data);
      setLoadingState(AsyncState.DONE);
    } catch (e) {
      if (e?.status === 401 || e?.status === 403) {
        history.push(LOGIN_INDEX);
      } else if (e?.status === 404) {
        setNotFound(true);
        setLoadingState(AsyncState.DONE);
      } else {
        setError(true);
        setLoadingState(AsyncState.ERROR);
      }
    }
  };

  return {
    employeeDetails,
    loadingState,
    notFound,
    error,
    lookup,
  };
};
